/**
 * Composer un nom d'affichage à partir d'un prénom et d'un nom, sans jamais produire de faux positif.
 *
 * POURQUOI CE HELPER EXISTE. L'écriture naturelle `` `${nom} ${prenom}` `` est un piège que le dépôt a
 * déjà payé : quand les deux champs sont vides elle rend UNE ESPACE, pas une chaîne vide. Or une espace
 * est une valeur « présente » pour JavaScript — elle traverse `?? '—'`, elle traverse `|| fallback`, et
 * elle neutralise SILENCIEUSEMENT tous les replis posés en aval. À l'écran, la cellule paraît vide sans
 * que rien n'ait signalé l'absence. Le repli n'est pas cassé : il n'est jamais atteint.
 *
 * La règle ici : un nom d'affichage est `null` dès qu'il ne reste rien après nettoyage. Les appelants
 * peuvent alors décider de leur repli en connaissance de cause.
 */

/**
 * @returns « Prénom Nom » nettoyé, ou `null` si aucune des deux parties ne porte de texte. Une seule
 *          partie renseignée suffit et est rendue seule (un prénom sans nom reste une identité utile).
 */
export function displayName(
  prenom: string | null | undefined,
  nom: string | null | undefined,
): string | null {
  const parts = [prenom, nom]
    .map((p) => (p ?? '').trim())
    .filter((p) => p !== '');
  return parts.length === 0 ? null : parts.join(' ');
}
